import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  Form,
  Button,
  Label,
  Modal,
  Input,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
} from "reactstrap";
import CgnTextbox from "../toolbox/CgnTextbox";
import CgnReactSelect from "../toolbox/CgnReactSelect";
import CgnAlert from "../toolbox/CgnAlert";
import CgnButtonGroup from "../toolbox/CgnButtonGroup";
import CgnLoader from "../toolbox/CgnLoader";
import CgnMessage from "../toolbox/CgnMessage";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import {
  URL,
  optionOfferStatuses,
  TaxType,
  TaxRateChoices,
  // PaymentMethodType,
  // DeliveryMethodType,
  // DeliveryTime,
  // Guaranty,
  CurrencyType,
  UserOperationClaimControl,
  resizeFile,
  fotoStyle,
  viewExchangeRate,
  yesNoStatus,
} from "../../redux/actions/constants";
import CgnButton from "../toolbox/CgnButton";
import CgnDatePicker from "../toolbox/CgnDatePicker";
import moment from "moment";
import CustomerAddUpdate from "../customer/CustomerAddUpdate";
import ProductAddUpdate from "../product/ProductAddUpdate";
import OfferCoverAddUpdate from "../offerCover/OfferCoverAddUpdate";
import OfferDefinitionAddUpdate from "../offerDefinition/OfferDefinitionAddUpdate";
import CgnTextEditor from "../toolbox/CgnTextEditor";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import LocationAddUpdate from "../location/LocationAddUpdate";
import ImageUploadMulti from "../toolbox/CgnImageUploadMulti";
import PictureUploadMulti from "../toolbox/CgnPictureUploadMulti";
import noImg from "../../images/no-img.png";
import pdfIcon from "../../images/pdfIcon.png";
import { use } from "react";

class OfferAddUpdate extends Component {
  state = {
    pageTitle: "Teklif Ekle",
    pageTitleAdd: "Teklif Ekle",
    pageTitleUpdate: "Teklif Güncelle",
    pageAddLink: "teklif-ekle",
    pageListLink: "teklif-listele",
    breadcrumb: [{ text: "Teklif", link: "#" }],
    isLoading: false,
    urlSplit: [],
    customerGuid: "",
    offerDate: "",
    optionDate: "",
    reminderDate: "",
    guid: "",
    costTotal: 0,
    total: 0,
    generalCostTotal: null,
    generalTotal: null,
    offerMultipleModal: false,
    taxRateValue: "",
    taxTypeValue: null,
    paymentMethodType: "",
    deliveryMethodType: "",
    deliveryTime: "",
    guaranty: "",
    title: "",
    description: "",
    descriptionHtml: "",
    discountPercent: "",
    discountValue: "",
    discountCostTotal: "",
    discountTotal: "",
    currencyType: "",
    currencyTypeError: "",
    isDiscountPercent: false,
    isDiscountValue: false,
    status: 1,
    customerError: "",
    offerDateError: "",
    optionDateError: "",
    reminderDateError: "",
    totalError: "",
    taxRateError: "",
    taxTypeError: "",
    paymentMethodTypeError: "",
    deliveryMethodTypeError: "",
    deliveryTimeError: "",
    guarantyError: "",
    productDataError: "",
    notDescription: "",
    offerCoverError: "",
    offerTypeGuid: "00000000-0000-0000-0000-000000000000",
    productGuid: "",
    coverGuid: "00000000-0000-0000-0000-000000000000",
    offerCoverButtonStyle: "",
    alertErrorMessage: "",
    isDeleted: false,
    isTrue: false,
    isNull: false,
    isOpenModalCustomer: false,
    isOpenModalProduct: false,
    isOpenModalOfferCover: false,
    isOpenModalDefinition: false,
    isOpenModalLocation: false,
    modalButtonIdx: 0,
    counter: -1,
    productData: [],
    offerCoverData: [],
    descriptionData: [],
    multipleProductArr: [],
    offerTypeArr: [],
    oldOfferDocumentDto: [],
    oldOfferImageDto: [],
    buttons: [
      {
        type: "button",
        color: "secondary",
        text: CgnMessage.clearButton,
        onClick: (event) => this.handleClear(event),
        disabled: this.isLoading,
      },
      {
        type: "submit",
        color: "primary",
        text: CgnMessage.saveButton,
        disabled: this.isLoading,
      },
    ],
    customerModalPlus: false,
    productModalPlus: false,
    definitionModalPlus: false,
    locationModalPlus: false,
    isExchangeRate: false,
    dolarValue: 0,
    euroValue: 0,
    exchangeRate: 0,
    teklifIptalSebebi: "",
    teklifIptalSebebiError: "",
    userArr: [],
    userGuid: "00000000-0000-0000-0000-000000000000",
    userNameSurname: "",
    isRead: false,
    isWrite: false,
    isDelete: false,
    offerNumber: 0,
    userArr2: [],
    createdByGuid: localStorage.getItem("membershipGuid"),
  };

  async componentDidMount() {
    this.setState({
      isLoading: true,
      customerModalPlus: await UserOperationClaimControl(1012),
      productModalPlus: await UserOperationClaimControl(1029),
      definitionModalPlus: await UserOperationClaimControl(1058),
      locationModalPlus: await UserOperationClaimControl(1055),
    });
    //
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    var statusType = 2; // sadece aktif olanları göstermesi için
    await axios
      .get(URL + "/customers/getlist/" + statusType, config)
      .then((response) => {
        var myArr = response.data.map(function (item) {
          return {
            value: item.guid,
            label: item.name,
          };
        });
        this.setState({
          customerArr: myArr,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
    await axios
      .get(URL + "/offerdefinitions/getlist/" + statusType, config)
      .then((response) => {
        var myArr = response.data.map(function (item) {
          return {
            value: item.guid,
            label: item.name,
          };
        });
        this.setState({
          definitionData: myArr,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
    await axios
      .get(URL + "/offerTypes/getlist/" + statusType, config)
      .then((response) => {
        var myArr = response.data.map(function (item) {
          return {
            value: item.guid,
            label: item.name,
          };
        });
        this.setState({
          offerTypeArr: myArr,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
    await axios
      .get(URL + "/products/getlist/" + statusType, config)
      .then((response) => {
        var myArr = response.data.map(function (item) {
          var label = `${item.code}-${item.name}`;
          if (item.supplierProductCode && item.supplierProductCode !== "") {
            label = `${item.code}-${item.supplierProductCode}-${item.name}`;
          }
          return {
            value: item.guid,
            label: label,
            salePrice: item.salePrice,
            buyPrice: item.buyPrice,
            code: item.code,
          };
        });
        this.setState({
          productArr: myArr,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
    await axios
      .get(URL + "/locations/getlist/" + statusType, config)
      .then((response) => {
        var myArr = response.data.map(function (item) {
          return {
            value: item.guid,
            label: item.name,
          };
        });
        this.setState({
          locationArr: myArr,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
    await axios
      .get(URL + "/offerCovers/getlist/" + statusType, config)
      .then((response) => {
        var myArr = response.data.map(function (item) {
          return {
            value: item.guid,
            label: item.name,
            src: item.image,
          };
        });
        this.setState({
          offerCoverData: myArr,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });

    await axios
      .get(URL + "/descriptions/getlist/" + statusType, config)
      .then((response) => {
        var myArr = response.data.map(function (item) {
          return {
            value: item.guid,
            label: item.title,
          };
        });
        this.setState({
          descriptionData: myArr,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });

    await axios
      .get(URL + "/kurbilgisi/getlast/", config)
      .then((response) => {
        this.setState({
          dolarValue: response.data.dolar,
          euroValue: response.data.euro,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });

    await axios
      .get(URL + "/users/getlistuser2", config)
      .then((response) => {
        const currentGuid = localStorage.getItem("membershipGuid");

        var myArr = response.data
          .filter((item) => item.isAdmin === false && item.guid !== currentGuid)
          .map((item) => ({
            value: item.guid,
            label: item.name,
          }));

        var myArr2 = response.data.map((item) => ({
          value: item.guid,
          label: item.name,
        }));

        this.setState({
          userArr: myArr,
          userArr2: myArr2,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });

    let urlSplit = window.location.pathname.split("/");
    if (urlSplit.length === 3 && urlSplit[1] === "teklif-guncelle") {
      this.setState({
        guid: urlSplit[urlSplit.length - 1],
        pageTitle: this.state.pageTitleUpdate,
      });
      this.getById(urlSplit[2]);
      await axios
        .get(URL + "/offers/get/" + urlSplit[2], config)
        .then((response) => {
          if (this.state.guid) {
            this.setState({
              customerGuid: response.data.customerGuid,
              offerDate: response.data.offerDate,
              optionDate: response.data.optionDate,
              reminderDate: response.data.reminderDate,
              productData: response.data.offerProductDto,
              costTotal: response.data.costTotal,
              total: response.data.total,
              taxTypeValue: response.data.taxType,
              taxRateValue: response.data.taxRate.toString(),
              generalCostTotal: response.data.generalCostTotal,
              generalTotal: response.data.generalTotal,
              guarantyGuid: response.data.guarantyGuid,
              offerTypeGuid: response.data.offerTypeGuid,
              paymentMethodTypeGuid: response.data.paymentMethodTypeGuid,
              deliveryMethodTypeGuid: response.data.deliveryMethodTypeGuid,
              deliveryTimeGuid: response.data.deliveryTimeGuid,
              description: response.data.description,
              descriptionHtml: response.data.description,
              description: EditorState.createWithContent(
                ContentState.createFromBlockArray(
                  htmlToDraft(response.data.description)
                )
              ),
              coverGuid: response.data.coverGuid,
              discountPercent: response.data.discountPercent,
              discountValue: response.data.discountValue,
              discountCostTotal: response.data.discountCostTotal,
              discountTotal: response.data.discountTotal,
              currencyType: response.data.currencyType,
              oldOfferDocumentDto: response.data.oldOfferDocumentDto,
              oldOfferImageDto: response.data.oldOfferImageDto,
              status: response.data.status,
              notDescription: response.data.notDescription,
              isExchangeRate: response.data.isExchangeRate,
              exchangeRate: response.data.exchangeRate,
              isLoading: false,
              teklifIptalSebebi: response.data.teklifIptalSebebi,
              authorizations: response.data.authorizations,
              offerNumber: response.data.offerNumber,
              createdByGuid: response.data.createdByGuid,
            });
          }
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    } else {
      this.setState({
        isLoading: false,
      });
    }
  }

  async componentDidUpdate(previousState) {
    let urlSplit = window.location.pathname.split("/");
    if (
      urlSplit.length === 2 &&
      this.state.pageTitle !== this.state.pageTitleAdd
    ) {
      this.setState({
        pageTitle: this.state.pageTitleAdd,
        urlSplit: urlSplit,
        customerGuid: "",
        offerDate: "",
        optionDate: "",
        reminderDate: "",
        costTotal: 0,
        total: 0,
        taxTypeValue: null,
        offerTypeGuid: "00000000-0000-0000-0000-000000000000",
        taxRateValue: "",
        paymentMethodType: null,
        deliveryMethodType: null,
        deliveryTime: null,
        guaranty: null,
        productData: [],
        descriptionData: [],
        description: "",
        descriptionHtml: "",
        coverGuid: "",
        discountPercent: "",
        notDescription: "",
        discountValue: "",
        discountCostTotal: "",
        discountTotal: "",
        currencyType: "",
        isDiscountPercent: false,
        isDiscountValue: false,
        status: 1,
        counter: -1,
        isExchangeRate: false,
        teklifIptalSebebi: "",
        userArr: [],
        userGuid: "00000000-0000-0000-0000-000000000000",
        userNameSurname: "",
        isRead: false,
        isWrite: false,
        isDelete: false,
        userArr: [],
        createdByGuid: localStorage.getItem("membershipGuid"),
      });
    }

    if (
      this.state.isOpenModalCustomer &&
      this.props.location.modalAddedCustomer !== undefined &&
      this.props.location.modalAddedCustomer.isModal !== undefined &&
      this.props.location.modalAddedCustomer.isModal === false
    ) {
      //
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var statusType = 2; // sadece aktif olanları göstermesi için
      axios
        .get(URL + "/customers/getlist/" + statusType, config)
        .then((response) => {
          var myArr = response.data.map(function (item) {
            return {
              value: item.guid,
              label: item.name,
            };
          });
          this.setState({
            customerArr: myArr,
            isLoading: false,
          });
          response.data.forEach((element) => {
            if (
              this.props.location.modalAddedCustomer.data &&
              element.name === this.props.location.modalAddedCustomer.data
            ) {
              this.setState({
                customerGuid: element.guid,
                customerError: "",
                alertErrorMessage: "",
              });
            }
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
      this.props.location.modalAddedCustomer.isModal = true;
      this.setState({
        isOpenModalCustomer: false,
      });
    }
    if (
      this.state.isOpenModalOfferCover &&
      this.props.location.modalAddedOfferCover !== undefined &&
      this.props.location.modalAddedOfferCover.isModal !== undefined &&
      this.props.location.modalAddedOfferCover.isModal === false
    ) {
      config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      statusType = 2; // sadece aktif olanları göstermesi için
      axios
        .get(URL + "/offerCovers/getlist/" + statusType, config)
        .then((response) => {
          var myArr = response.data.map(function (item) {
            return {
              value: item.guid,
              label: item.name,
              src: item.image,
            };
          });
          this.setState({
            offerCoverData: myArr,
            isLoading: false,
          });
          response.data.forEach((element) => {
            if (
              this.props.location.modalAddedOfferCover.name &&
              element.name === this.props.location.modalAddedOfferCover.name
            ) {
              this.setState({
                coverGuid: element.guid,
                offerCoverError: "",
                alertErrorMessage: "",
              });
            }
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
      this.props.location.modalAddedOfferCover.isModal = true;
      this.setState({
        isOpenModalOfferCover: false,
      });
    }
    if (
      this.state.isOpenModalProduct &&
      this.props.location.modalAddedProduct !== undefined &&
      this.props.location.modalAddedProduct.isModal !== undefined &&
      this.props.location.modalAddedProduct.isModal === false
    ) {
      config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      statusType = 2; // sadece aktif olanları göstermesi için
      await axios
        .get(URL + "/products/getlist/" + statusType, config)
        .then((response) => {
          var myArr = response.data.map(function (item) {
            var label = `${item.code}-${item.name}`;
            if (item.supplierProductCode && item.supplierProductCode !== "") {
              label = `${item.code}-${item.supplierProductCode}-${item.name}`;
            }
            return {
              value: item.guid,
              label: label,
              code: item.code,
            };
          });
          this.setState({
            productArr: myArr,
            isLoading: false,
          });
          let productData = this.state.productData;
          response.data.forEach((element) => {
            if (
              this.props.location.modalAddedProduct.data &&
              `${element.code}-${element.name}` ===
                this.props.location.modalAddedProduct.data &&
              this.state.modalButtonIdx !== previousState
            ) {
              productData[this.state.modalButtonIdx].productGuid = element.guid;
              productData[this.state.modalButtonIdx].productError = "";
            }
          });
          if (this.props.location.modalAddedProduct.salePrice) {
            productData[this.state.modalButtonIdx].costPrice =
              this.props.location.modalAddedProduct.buyPrice;
            productData[this.state.modalButtonIdx].unitPrice =
              this.props.location.modalAddedProduct.salePrice;
            productData[this.state.modalButtonIdx].piece = 1;
            productData[this.state.modalButtonIdx].productUnitPriceError = "";
            productData[this.state.modalButtonIdx].productPieceError = "";
          }
          this.setState({
            alertErrorMessage: "",
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
      this.props.location.modalAddedProduct.isModal = true;
      this.setState({
        isOpenModalProduct: false,
      });
    }
    if (
      this.state.isOpenModalDefinition &&
      this.props.location.modalAddedDefinition !== undefined &&
      this.props.location.modalAddedDefinition.isModal !== undefined &&
      this.props.location.modalAddedDefinition.isModal === false
    ) {
      config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      statusType = 2; // sadece aktif olanları göstermesi için
      axios
        .get(URL + "/offerdefinitions/getlist/" + statusType, config)
        .then((response) => {
          var myArr = response.data.map(function (item) {
            return {
              value: item.guid,
              label: item.name,
              src: item.image,
            };
          });
          this.setState({
            definitionData: myArr,
            isLoading: false,
          });
          response.data.forEach((element) => {
            if (
              this.props.location.modalAddedDefinition.data &&
              element.name === this.props.location.modalAddedDefinition.data
            ) {
              if (this.state.isOpenModalDefinitionGuaranty) {
                this.setState({
                  isOpenModalDefinitionGuaranty:
                    !this.state.isOpenModalDefinitionGuaranty,
                  guarantyGuid: element.guid,
                  guarantyError: "",
                  alertErrorMessage: "",
                });
              } else if (this.state.isOpenModalDefinitionPaymentMethodType) {
                this.setState({
                  isOpenModalDefinitionPaymentMethodType:
                    !this.state.isOpenModalDefinitionPaymentMethodType,
                  paymentMethodTypeGuid: element.guid,
                  paymentMethodTypeError: "",
                  alertErrorMessage: "",
                });
              } else if (this.state.isOpenModalDefinitionDeliveryMethodType) {
                this.setState({
                  isOpenModalDefinitionDeliveryMethodType:
                    !this.state.isOpenModalDefinitionDeliveryMethodType,
                  deliveryMethodTypeGuid: element.guid,
                  deliveryMethodTypeError: "",
                  alertErrorMessage: "",
                });
              } else if (this.state.isOpenModalDefinitionDeliveryTime) {
                this.setState({
                  isOpenModalDefinitionDeliveryTime:
                    !this.state.isOpenModalDefinitionDeliveryTime,
                  deliveryTimeGuid: element.guid,
                  deliveryTimeError: "",
                  alertErrorMessage: "",
                });
              }
            }
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
      this.props.location.modalAddedDefinition.isModal = true;
      this.setState({
        isOpenModalDefinition: false,
      });
    }
    if (
      this.state.isOpenModalLocation &&
      this.props.location.modalAddedLocation !== undefined &&
      this.props.location.modalAddedLocation.isModal !== undefined &&
      this.props.location.modalAddedLocation.isModal === false
    ) {
      //
      config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      statusType = 2; // sadece aktif olanları göstermesi için
      await axios
        .get(URL + "/locations/getlist/" + statusType, config)
        .then((response) => {
          var myArr = response.data.map(function (item) {
            return {
              value: item.guid,
              label: item.name,
            };
          });
          this.setState({
            locationArr: myArr,
            isLoading: false,
          });
          let productData = this.state.productData;
          response.data.forEach((element) => {
            if (
              this.props.location.modalAddedLocation.data &&
              element.name === this.props.location.modalAddedLocation.data &&
              this.state.modalButtonIdx !== previousState
            ) {
              productData[this.state.modalButtonIdx].locationGuid =
                element.guid;
              productData[this.state.modalButtonIdx].locationError = "";
            }
          });
          this.setState({
            alertErrorMessage: "",
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
      this.props.location.modalAddedLocation.isModal = true;
      this.setState({
        isOpenModalLocation: false,
      });
    }
  }

  getById(guid) {
    this.setState({
      isLoading: true,
      guid: guid,
    });
  }

  uploadedImage3 = async (event) => {
    let array = this.state.oldOfferDocumentDto;
    const files = event.target.files;
    for (var i = 0; i < files.length; i++) {
      const file = event.target.files[i];
      const formData = new FormData();
      formData.append("files", file);
      await axios
        .post(URL + "/uploads2/add", formData)
        .then((response) => {
          array.push({
            image: response.data,
            imageName: file.name,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
          });
        });
    }
    await this.setState({ oldOfferDocumentDto: array });
  };

  deleteImage3 = (event) => {
    var index = -1;
    let array = this.state.oldOfferDocumentDto;
    this.state.oldOfferDocumentDto.forEach((element) => {
      index++;
      if (element.image === event) {
        if (index !== -1) {
          array.splice(index, 1);
          this.setState({ oldOfferDocumentDto: array });
        }
      }
    });
  };

  uploadedImage = async (event) => {
    let array = this.state.oldOfferImageDto;
    for (var i = 0; i < event.target.files.length; i++) {
      const file = event.target.files[i];
      if (file.type === "image/png" || file.type === "image/jpeg") {
        const image = await resizeFile(file, 1000);
        array.push({
          image: image,
          imageName: file.name,
        });
      }
    }
    await this.setState({ oldOfferImageDto: array });
  };

  deleteImage = (event) => {
    var index = -1;
    let array = this.state.oldOfferImageDto;
    this.state.oldOfferImageDto.forEach((element) => {
      index++;
      if (element.image === event) {
        if (index !== -1) {
          array.splice(index, 1);
          this.setState({ oldOfferImageDto: array });
        }
      }
    });
  };

  handleEditorChange = (editorState, editorStateHtml) => {
    if (editorStateHtml) {
      this.setState({
        description: editorState,
        descriptionHtml: editorStateHtml,
        descriptionError: "",
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        descriptionError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  };

  handleChange = async (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
    this.setState({
      customerError: "",
      totalError: "",
      descriptionError: "",
      taxRateError: "",
      taxTypeError: "",
      currencyTypeError: "",
      alertErrorMessage: "",
    });
    if (name === "customerGuid" && value === "") {
      this.setState({
        customerError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (name === "currencyType" && value === "") {
      this.setState({
        currencyTypeError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.discountPercent) {
      await this.setState({
        discountValue: "",
        isDiscountValue: true,
      });
    }
    if (this.state.discountValue) {
      await this.setState({
        discountPercent: "",
        isDiscountPercent: true,
      });
    }
    if (this.state.discountPercent === "") {
      await this.setState({
        isDiscountValue: false,
      });
    }
    if (this.state.discountValue === "") {
      await this.setState({
        isDiscountPercent: false,
      });
    }
  };

  TaxCalculate = async () => {
    if (
      this.state.taxTypeValue === 1 &&
      this.state.costTotal &&
      this.state.costTotal !== 0 &&
      this.state.taxRateValue
    ) {
      var generalCostTotal = (
        this.state.costTotal *
        (1 + parseInt(this.state.taxRateValue) / 100)
      ).toFixed(2);
      if (this.state.generalCostTotal !== generalCostTotal) {
        await this.setState({
          generalCostTotal: generalCostTotal,
        });
      }
    }
    if (
      this.state.taxTypeValue === 1 &&
      this.state.total &&
      this.state.total !== 0 &&
      this.state.taxRateValue
    ) {
      var generalTotal = (
        this.state.total *
        (1 + parseInt(this.state.taxRateValue) / 100)
      ).toFixed(2);
      if (this.state.generalTotal !== generalTotal) {
        await this.setState({
          generalTotal: generalTotal,
        });
      }
    }
    if (
      this.state.taxTypeValue === 2 &&
      this.state.costTotal &&
      this.state.taxRateValue
    ) {
      if (this.state.generalCostTotal !== this.state.costTotal) {
        await this.setState({
          generalCostTotal: this.state.costTotal,
        });
      }
    }
    if (
      this.state.taxTypeValue === 2 &&
      this.state.total &&
      this.state.taxRateValue
    ) {
      if (this.state.generalTotal !== this.state.total) {
        await this.setState({
          generalTotal: this.state.total,
        });
      }
    }
    if (this.state.total && this.state.taxTypeValue === 3) {
      if (this.state.generalTotal !== this.state.total) {
        await this.setState({
          generalTotal: this.state.total,
        });
      }
    }
    if (this.state.costTotal && this.state.taxTypeValue === 3) {
      if (this.state.generalCostTotal !== this.state.costTotal) {
        await this.setState({
          generalCostTotal: this.state.costTotal,
        });
      }
    }
    if (this.state.costTotal === 0) {
      if (
        this.state.generalCostTotal &&
        this.state.generalCostTotal !== this.state.costTotal
      ) {
        await this.setState({
          generalCostTotal: 0,
        });
      }
    }
    if (this.state.total === 0) {
      if (
        this.state.generalTotal &&
        this.state.generalTotal !== this.state.total
      ) {
        await this.setState({
          generalTotal: 0,
        });
      }
    }
  };
  DiscountCalculate = async () => {
    var totalAmount = 0;
    if (this.state.generalTotal && this.state.discountPercent) {
      totalAmount =
        this.state.generalTotal * (1 - this.state.discountPercent / 100);
      if (this.state.discountTotal !== totalAmount) {
        this.state.discountTotal = totalAmount;
      }
    }
    if (this.state.generalTotal && this.state.discountPercent === "") {
      this.state.discountTotal = "";
    }
    if (this.state.generalTotal && this.state.discountValue) {
      totalAmount = this.state.generalTotal - this.state.discountValue;
      if (this.state.discountTotal !== totalAmount) {
        this.state.discountTotal = totalAmount;
      }
    }
  };

  async handleTaxTypeSelectChange(option) {
    if (option) {
      await this.setState({
        taxTypeValue: option.value,
        taxTypeError: "",
        alertErrorMessage: "",
      });
      if (option.value === 3) {
        this.setState({
          taxRateValue: "0",
          isTrue: true,
        });
      } else {
        this.setState({
          taxRateValue: "",
          isTrue: false,
        });
      }
    } else {
      await this.setState({
        taxTypeValue: null,
        taxTypeError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    this.PriceCalculate(null);
  }

  async handleTaxRateSelectChange(option) {
    if (option) {
      await this.setState({
        taxRateValue: option.value,
        taxRateError: "",
        alertErrorMessage: "",
      });
    } else {
      await this.setState({
        taxRateValue: "",
        taxRateError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    this.PriceCalculate(null);
  }

  handleOfferDateChange(offerDate) {
    if (offerDate) {
      this.setState({
        offerDate: offerDate,
        offerDateError: "",
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        offerDate: "",
        offerDateError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  handleOptionDateChange(optionDate) {
    if (optionDate) {
      this.setState({
        optionDate: optionDate,
        optionDateError: "",
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        optionDate: "",
        optionDateError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  handleReminderDateChange(reminderDate) {
    if (reminderDate) {
      this.setState({
        reminderDate: reminderDate,
        reminderDateError: "",
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        reminderDate: "",
        reminderDateError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  handleCustomerSelectChange(option) {
    if (option) {
      this.setState({
        customerGuid: option.value,
        customerError: "",
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        customerGuid: "",
        customerError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  handleOfferTypeSelectChange(option) {
    if (option) {
      this.setState({
        offerTypeGuid: option.value,
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        offerTypeGuid: "00000000-0000-0000-0000-000000000000",
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  handlePaymentMethodTypeSelectChange(option) {
    if (option) {
      this.setState({
        paymentMethodTypeGuid: option.value,
        paymentMethodTypeError: "",
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        paymentMethodTypeGuid: "",
        paymentMethodTypeError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  handleDeliveryMethodTypeSelectChange(option) {
    if (option) {
      this.setState({
        deliveryMethodTypeGuid: option.value,
        deliveryMethodTypeError: "",
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        deliveryMethodTypeGuid: "",
        deliveryMethodTypeError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  handleDeliveryTimeSelectChange(option) {
    if (option) {
      this.setState({
        deliveryTimeGuid: option.value,
        deliveryTimeError: "",
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        deliveryTimeGuid: "",
        deliveryTimeError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  handleGuarantySelectChange(option) {
    if (option) {
      this.setState({
        guarantyGuid: option.value,
        guarantyError: "",
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        guarantyGuid: "",
        guarantyError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  handleChangeMultipleProduct(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
      multipleProductArr: value,
    });
  }

  handleClickMultipleProduct = async () => {
    this.setState({
      offerMultipleModal: !this.state.offerMultipleModal,
    });
    var x = this.state.multipleProductArr.split("\n");
    await this.state.productArr.forEach((item) => {
      x.forEach((item2) => {
        if (item.code === item2) {
          this.handleMultipleProductAdd(item.value);
        }
      });
    });
  };

  handleMultipleProductAdd = async (value) => {
    let productData = this.state.productData;
    await productData.push({
      productGuid: value,
      locationGuid: "",
      piece: 1,
      costPrice: 1,
      unitPrice: 1,
      total: 1,
      costTotal: 1,
      locationError: CgnMessage.textErrorMessage,
    });
    await this.setState({
      counter: this.state.counter + 1,
    });
    if (
      productData[this.state.counter].productGuid === "" ||
      productData[this.state.counter].piece === 0 ||
      productData[this.state.counter].unitPrice === 0 ||
      productData[this.state.counter].locationGuid === ""
    ) {
      this.setState({
        isNull: true,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    this.setState({ productData: productData });
  };

  handleProductSelectChange(option) {
    if (option) {
      this.setState({
        productGuid: option.value,
        productError: "",
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        productGuid: "",
        productError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  handlePaymentMethodSelectChange(option) {
    if (option) {
      this.setState({
        paymentMethodType: option.value,
        paymentMethodTypeError: "",
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        paymentMethodType: null,
        paymentMethodTypeError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  handleDeliveryMethodSelectChange(option) {
    if (option) {
      this.setState({
        deliveryMethodType: option.value,
        deliveryMethodTypeError: "",
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        deliveryMethodType: null,
        deliveryMethodTypeError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  // handleDeliveryTimeSelectChange(option) {
  //   if (option) {
  //     this.setState({
  //       deliveryTime: option.value,
  //       deliveryTimeError: "",
  //       alertErrorMessage: "",
  //     });
  //   } else {
  //     this.setState({
  //       deliveryTime: null,
  //       deliveryTimeError: CgnMessage.textErrorMessage,
  //       alertErrorMessage: CgnMessage.alertErrorMessage,
  //     });
  //   }
  // }

  // handleGuarantySelectChange(option) {
  //   if (option) {
  //     this.setState({
  //       guaranty: option.value,
  //       guarantyError: "",
  //       alertErrorMessage: "",
  //     });
  //   } else {
  //     this.setState({
  //       guaranty: null,
  //       guarantyError: CgnMessage.textErrorMessage,
  //       alertErrorMessage: CgnMessage.alertErrorMessage,
  //     });
  //   }
  // }

  handleOfferCoverSelectChange(option) {
    if (option) {
      this.setState({
        coverGuid: option,
      });
    }
  }

  handleCurrencyTypeSelectChange(option) {
    if (option) {
      this.setState({
        currencyType: option.value,
        currencyTypeError: "",
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        currencyType: "",
        currencyTypeError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    this.PriceCalculate(null);
  }

  handleStatusSelectChange(status) {
    if (status) {
      this.setState({
        status: status.value,
      });
    }
  }

  handleUserSelectChange(user) {
    if (user) {
      this.setState({
        userGuid: user.value,
        userNameSurname: user.label,
      });
    }
  }

  handleUser2SelectChange(user) {
    if (user) {
      this.setState({
        createdByGuid: user.value,
      });
    }
  }

  handleReadSelectChange(user) {
    if (user) {
      this.setState({
        isRead: user.value,
      });
    }
  }

  handleWriteSelectChange(user) {
    if (user) {
      this.setState({
        isWrite: user.value,
      });
    }
  }

  handleDeleteSelectChange(user) {
    if (user) {
      this.setState({
        isDelete: user.value,
      });
    }
  }

  handleIsExchangeRateSelectChange(isExchangeRate) {
    if (isExchangeRate) {
      this.setState({
        isExchangeRate: isExchangeRate.value,
      });
    }
  }

  addModalCustomer = () => {
    this.setState({
      isOpenModalCustomer: !this.state.isOpenModalCustomer,
    });
  };

  addModalProduct = async (idx) => {
    await this.setState({
      isOpenModalProduct: !this.state.isOpenModalProduct,
      modalButtonIdx: idx,
    });
  };

  addModalOfferCover = async () => {
    await this.setState({
      isOpenModalOfferCover: !this.state.isOpenModalOfferCover,
    });
  };

  addModalDefinitionGuaranty = () => {
    this.setState({
      isOpenModalDefinition: !this.state.isOpenModalDefinition,
      isOpenModalDefinitionGuaranty: !this.state.isOpenModalDefinitionGuaranty,
    });
  };

  addModalDefinitionPaymentMethodType = () => {
    this.setState({
      isOpenModalDefinition: !this.state.isOpenModalDefinition,
      isOpenModalDefinitionPaymentMethodType:
        !this.state.isOpenModalDefinitionPaymentMethodType,
    });
  };

  addModalDefinitionDeliveryMethodType = () => {
    this.setState({
      isOpenModalDefinition: !this.state.isOpenModalDefinition,
      isOpenModalDefinitionDeliveryMethodType:
        !this.state.isOpenModalDefinitionDeliveryMethodType,
    });
  };

  addModalDefinitionDeliveryTime = () => {
    this.setState({
      isOpenModalDefinition: !this.state.isOpenModalDefinition,
      isOpenModalDefinitionDeliveryTime:
        !this.state.isOpenModalDefinitionDeliveryTime,
    });
  };

  addModalDefinition = async () => {
    await this.setState({
      isOpenModalDefinition: !this.state.isOpenModalDefinition,
      isOpenModalDefinitionDeliveryTime:
        !this.state.isOpenModalDefinitionDeliveryTime,
    });
  };

  addModalLocation = async (idx) => {
    await this.setState({
      isOpenModalLocation: !this.state.isOpenModalLocation,
      modalButtonIdx: idx,
    });
  };

  handleClear = (event) => {
    this.clearPage();
  };

  clearPage() {
    var productData = this.state.productData;
    productData.forEach((item) => {
      item.productGuid = null;
      item.piece = "";
      item.costPrice = "";
      item.unitPrice = "";
      item.costTotal = 0;
      item.total = 0;
      item.productError = CgnMessage.textErrorMessage;
      item.productPieceError = CgnMessage.textErrorMessage;
      item.productUnitPriceError = CgnMessage.textErrorMessage;
    });
    this.setState({
      customerGuid: "",
      costTotal: "",
      total: "",
      taxRateValue: "",
      taxTypeValue: null,
      generalTotal: "",
      offerDate: "",
      optionDate: "",
      notDescription: "",
      reminderDate: "",
      offerTypeGuid: "00000000-0000-0000-0000-000000000000",
      paymentMethodType: null,
      deliveryMethodType: null,
      deliveryTime: null,
      guaranty: null,
      description: "",
      descriptionHtml: "",
      coverGuid: "",
      discountPercent: "",
      discountValue: "",
      costTotal: "",
      discountTotal: "",
      currencyType: "",
      isDiscountPercent: false,
      isDiscountValue: false,
      status: 1,
      counter: -1,
      isExchangeRate: false,
      alertErrorMessage: CgnMessage.alertErrorMessage,
      customerError: CgnMessage.textErrorMessage,
      totalError: CgnMessage.textErrorMessage,
      taxRateError: CgnMessage.textErrorMessage,
      taxTypeError: CgnMessage.textErrorMessage,
      offerDateError: CgnMessage.textErrorMessage,
      optionDateError: CgnMessage.textErrorMessage,
      reminderDateError: CgnMessage.textErrorMessage,
      paymentMethodTypeError: CgnMessage.textErrorMessage,
      deliveryMethodTypeError: CgnMessage.textErrorMessage,
      deliveryTimeError: CgnMessage.textErrorMessage,
      guarantyError: CgnMessage.textErrorMessage,
      currencyTypeError: CgnMessage.textErrorMessage,
      productDataError: CgnMessage.textErrorMessage,
      offerCoverError: CgnMessage.textErrorMessage,
      teklifIptalSebebi: "",
      teklifIptalSebebiError: CgnMessage.textErrorMessage,
    });
  }

  toggle = () => {
    this.setState({
      offerMultipleModal: !this.state.offerMultipleModal,
    });
  };

  handleAuthorizationAdd = async () => {
    const newAuthorization = {
      childGuid: "00000000-0000-0000-0000-000000000000",
      createdAt: null,
      createdAtDateTime: null,
      createdBy: null,
      groupGuid: "00000000-0000-0000-0000-000000000000",
      guid: "00000000-0000-0000-0000-000000000000",
      isChanged: true,
      isDelete: this.state.isDelete,
      isRead: this.state.isRead,
      isWrite: this.state.isWrite,
      memberGuid: this.state.userGuid,
      memberNameSurname: this.state.userNameSurname,
      status: null,
      type: null,
      updatedAt: null,
      updatedBy: null,
    };

    if (
      !newAuthorization.memberGuid ||
      (!newAuthorization.isRead &&
        !newAuthorization.isWrite &&
        !newAuthorization.isDelete)
    ) {
      return;
    }

    await this.setState((prevState) => {
      const authorizationsArray = Array.isArray(prevState.authorizations)
        ? prevState.authorizations
        : [];

      const exists = authorizationsArray.some(
        (auth) => auth.memberGuid === newAuthorization.memberGuid
      );

      if (exists) {
        return null;
      }

      return {
        authorizations: [...authorizationsArray, newAuthorization],
      };
    });
  };

  handleProductAdd = async () => {
    let array = this.state.productData;
    await array.push({
      productGuid: "",
      locationGuid: "",
      piece: 0,
      costPrice: 0,
      unitPrice: 0,
      costTotal: 0,
      total: 0,
      productError: CgnMessage.textErrorMessage,
      locationError: CgnMessage.textErrorMessage,
      productPieceError: CgnMessage.textErrorMessage,
      productUnitPriceError: CgnMessage.textErrorMessage,
    });
    await this.setState({
      counter: this.state.counter + 1,
    });
    if (array[this.state.counter].productGuid) {
      return array[this.state.counter].productError === "";
    }
    if (array[this.state.counter].locationGuid) {
      return array[this.state.counter].locationError === "";
    }
    if (array[this.state.counter].piece) {
      return array[this.state.counter].productPieceError === "";
    }
    if (array[this.state.counter].unitPrice) {
      return array[this.state.counter].productUnitPriceError === "";
    }
    if (
      array[this.state.counter].productGuid === "" ||
      array[this.state.counter].locationGuid === "" ||
      array[this.state.counter].piece === 0 ||
      array[this.state.counter].unitPrice === 0
    ) {
      this.setState({
        isNull: true,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    this.setState({ productData: array });
  };

  handleProductPieceTextBoxChange(e, idx) {
    let productData = this.state.productData;
    productData[idx].piece = parseFloat(e.target.value);
    this.setState({
      productData: productData,
    });
    this.productRequiredField();
    this.ProductPriceCalculate();
  }

  handleProductUnitPriceTextBoxChange(e, idx) {
    let productData = this.state.productData;
    productData[idx].unitPrice = parseFloat(e.target.value);
    this.setState({
      productData: productData,
    });
    this.productRequiredField();
    this.ProductPriceCalculate();
  }

  handleProductCostPriceTextBoxChange(e, idx) {
    let productData = this.state.productData;
    productData[idx].costPrice = parseFloat(e.target.value);
    this.setState({
      productData: productData,
    });
    this.productRequiredField();
    this.ProductPriceCalculate();
  }

  handleProductInputValueChange(option, idx) {
    let productData = this.state.productData;
    if (option) {
      productData[idx].productGuid = option.value;
      productData[idx].piece = 1;
      productData[idx].costPrice = option.buyPrice;
      productData[idx].unitPrice = option.salePrice;
      productData[idx].productError = "";
      productData[idx].productPieceError = "";
      productData[idx].productUnitPriceError = "";
      this.setState({
        productData: productData,
      });
    } else {
      productData[idx].productGuid = null;
      productData[idx].piece = 0;
      productData[idx].costPrice = 0;
      productData[idx].unitPrice = 0;
      productData[idx].productError = CgnMessage.textErrorMessage;
      productData[idx].productPieceError = CgnMessage.textErrorMessage;
      productData[idx].productUnitPriceError = CgnMessage.textErrorMessage;
      this.setState({
        productData: productData,
      });
    }
    this.productRequiredField();
    this.ProductPriceCalculate();
  }

  handleLocationInputValueChange(option, idx) {
    let productData = this.state.productData;
    if (option) {
      productData[idx].locationGuid = option.value;
      productData[idx].locationError = "";
      this.setState({
        productData: productData,
      });
    } else {
      productData[idx].locationGuid = "";
      productData[idx].locationError = CgnMessage.textErrorMessage;
      this.setState({
        productData: productData,
      });
    }
    this.productRequiredField();
    this.ProductPriceCalculate();
  }

  ProductPriceCalculate = () => {
    var totalProductPrice = 0;
    var costTotalProductPrice = 0;
    this.state.productData.forEach((item) => {
      item.total = (
        parseFloat(item.piece) * parseFloat(item.unitPrice)
      ).toFixed(2);
      totalProductPrice += parseFloat(item.total);
      item.costTotal = (
        parseFloat(item.piece) * parseFloat(item.costPrice)
      ).toFixed(2);
      costTotalProductPrice += parseFloat(item.costTotal);
    });
    this.state.costTotal = parseFloat(costTotalProductPrice).toFixed(2);
    this.state.total = parseFloat(totalProductPrice).toFixed(2);
    this.PriceCalculate(null);
  };

  productRequiredField = () => {
    var arr = this.state.productData;
    arr.forEach((item) => {
      if (
        !item.productGuid &&
        item.piece &&
        item.unitPrice &&
        item.locationGuid
      ) {
        item.productError = CgnMessage.textErrorMessage;
        item.productPieceError = "";
        item.productUnitPriceError = "";
        item.locationError = "";
        this.setState({
          alertErrorMessage: CgnMessage.alertErrorMessage,
          isNull: true,
        });
      }
      if (
        item.productGuid &&
        item.piece &&
        item.unitPrice &&
        !item.locationGuid
      ) {
        item.locationError = CgnMessage.textErrorMessage;
        item.productPieceError = "";
        item.productUnitPriceError = "";
        item.productError = "";
        this.setState({
          alertErrorMessage: CgnMessage.alertErrorMessage,
          isNull: true,
        });
      }
      if (
        !item.productGuid &&
        item.piece &&
        item.unitPrice &&
        !item.locationGuid
      ) {
        item.locationError = CgnMessage.textErrorMessage;
        item.productError = CgnMessage.textErrorMessage;
        item.productPieceError = "";
        item.productUnitPriceError = "";
        this.setState({
          alertErrorMessage: CgnMessage.alertErrorMessage,
          isNull: true,
        });
      }
      if (
        item.productGuid &&
        !item.piece &&
        item.unitPrice &&
        item.locationGuid
      ) {
        item.productPieceError = CgnMessage.textErrorMessage;
        item.productError = "";
        item.productUnitPriceError = "";
        item.locationError = "";
        this.setState({
          alertErrorMessage: CgnMessage.alertErrorMessage,
          isNull: true,
        });
      }
      if (
        !item.productGuid &&
        !item.piece &&
        item.unitPrice &&
        item.locationGuid
      ) {
        item.productError = CgnMessage.textErrorMessage;
        item.productPieceError = CgnMessage.textErrorMessage;
        item.productUnitPriceError = "";
        item.locationError = "";
        this.setState({
          alertErrorMessage: CgnMessage.alertErrorMessage,
          isNull: true,
        });
      }
      if (
        !item.productGuid &&
        item.piece &&
        !item.unitPrice &&
        item.locationGuid
      ) {
        item.productError = CgnMessage.textErrorMessage;
        item.ProductUnitPriceError = CgnMessage.textErrorMessage;
        item.productPieceError = "";
        item.locationError = "";
        this.setState({
          alertErrorMessage: CgnMessage.alertErrorMessage,
          isNull: true,
        });
      }
      if (
        item.productGuid &&
        !item.piece &&
        !item.unitPrice &&
        !item.locationGuid
      ) {
        item.productPieceError = CgnMessage.textErrorMessage;
        item.productUnitPriceError = CgnMessage.textErrorMessage;
        item.locationError = CgnMessage.textErrorMessage;
        item.productError = "";
        this.setState({
          alertErrorMessage: CgnMessage.alertErrorMessage,
          isNull: true,
        });
      }
      if (
        item.productGuid &&
        item.piece &&
        item.unitPrice &&
        item.locationGuid
      ) {
        item.locationError = "";
        item.productError = "";
        item.productPieceError = "";
        item.productUnitPriceError = "";
        this.setState({
          alertErrorMessage: "",
          isNull: false,
        });
      }
      if (
        !item.productGuid &&
        !item.piece &&
        !item.unitPrice &&
        !item.locationGuid
      ) {
        item.locationError = CgnMessage.textErrorMessage;
        item.productError = CgnMessage.textErrorMessage;
        item.productPieceError = CgnMessage.textErrorMessage;
        item.productUnitPriceError = CgnMessage.textErrorMessage;
        this.setState({
          alertErrorMessage: CgnMessage.alertErrorMessage,
          isNull: true,
        });
      }
    });
  };

  async handleProductRemove(idx) {
    let someArray = this.state.productData;
    someArray.splice(idx, 1);
    await this.setState({
      productData: someArray,
      counter: this.state.counter - 1,
    });
    if (idx === 0) {
      this.setState({
        alertErrorMessage: "",
        costTotal: 0,
        total: 0,
      });
    }
  }

  async handleAuthorizationRemove(guid) {
    const updated = this.state.authorizations.filter(
      (auth) => auth.guid?.toLowerCase() !== guid.toLowerCase()
    );

    await this.setState({ authorizations: updated });
  }

  handleSave = async (event) => {
    event.preventDefault();
    this.setState({
      customerError: "",
      totalError: "",
      taxRateError: "",
      taxTypeError: "",
      offerDateError: "",
      optionDateError: "",
      reminderDateError: "",
      paymentMethodTypeError: "",
      deliveryMethodTypeError: "",
      deliveryTimeError: "",
      guarantyError: "",
      currencyTypeError: "",
      alertErrorMessage: "",
      productDataError: "",
      offerCoverError: "",
    });
    if (this.state.customerGuid === "") {
      this.setState({
        customerError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.taxTypeValue === null) {
      this.setState({
        taxTypeError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.taxRateValue === "") {
      this.setState({
        taxRateError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.offerDate === "") {
      this.setState({
        offerDateError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.optionDate === "") {
      this.setState({
        optionDateError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.reminderDate === "") {
      this.setState({
        reminderDateError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.currencyType === "") {
      this.setState({
        currencyTypeError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (!this.state.productData || this.state.productData.length === 0) {
      this.setState({
        productDataError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (
      this.state.status === 3 &&
      (this.state.teklifIptalSebebi === "" ||
        this.state.teklifIptalSebebi === null)
    ) {
      this.setState({
        teklifIptalSebebiError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    } else if (
      this.state.customerGuid !== "" &&
      this.state.total &&
      this.state.taxTypeValue &&
      this.state.taxRateValue &&
      this.state.offerDate !== "" &&
      this.state.optionDate !== "" &&
      this.state.reminderDate !== "" &&
      this.state.currencyType &&
      this.state.productData &&
      this.state.productData.length > 0 &&
      this.state.isNull === false &&
      (this.state.status !== 3 ||
        (this.state.status === 3 &&
          this.state.teklifIptalSebebi !== "" &&
          this.state.teklifIptalSebebi !== null))
    ) {
      this.setState({
        isLoading: true,
      });
      //
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var productData = [];
      this.state.productData.forEach((element) => {
        productData.push({
          guid: element.guid,
          productGuid: element.productGuid,
          locationGuid: element.locationGuid,
          piece: element.piece,
          costPrice: element.costPrice,
          unitPrice: element.unitPrice,
          costTotal: parseFloat(element.costTotal),
          total: parseFloat(element.total),
        });
      });
      var myObj = {
        customerGuid: this.state.customerGuid,
        offerDate: moment(this.state.offerDate).format("DD/MM/YYYY"),
        optionDate: moment(this.state.optionDate).format("DD/MM/YYYY"),
        reminderDate: moment(this.state.reminderDate).format("DD/MM/YYYY"),
        taxType: this.state.taxTypeValue,
        taxRate: parseInt(this.state.taxRateValue),
        costTotal: parseFloat(this.state.costTotal),
        total: parseFloat(this.state.total),
        generalCostTotal: parseFloat(this.state.generalCostTotal),
        generalTotal: parseFloat(this.state.generalTotal),
        guarantyGuid: this.state.guarantyGuid,
        offerTypeGuid: this.state.offerTypeGuid,
        paymentMethodTypeGuid: this.state.paymentMethodTypeGuid,
        deliveryMethodTypeGuid: this.state.deliveryMethodTypeGuid,
        deliveryTimeGuid: this.state.deliveryTimeGuid,
        description: this.state.descriptionHtml,
        coverGuid: this.state.coverGuid,
        oldOfferDocumentDto: this.state.oldOfferDocumentDto,
        oldOfferImageDto: this.state.oldOfferImageDto,
        currencyType: this.state.currencyType,
        discountPercent:
          this.state.discountPercent !== ""
            ? parseInt(this.state.discountPercent)
            : 0,
        discountValue:
          this.state.discountValue !== ""
            ? parseFloat(this.state.discountValue)
            : 0,
        discountTotal: parseFloat(this.state.discountTotal),
        discountCostTotal: parseFloat(this.state.discountCostTotal),
        status: this.state.status,
        offerProductDto: productData,
        notDescription: this.state.notDescription,
        isExchangeRate: this.state.isExchangeRate,
        dolarValue: this.state.dolarValue,
        euroValue: this.state.euroValue,
        teklifIptalSebebi: this.state.teklifIptalSebebi,
        authorizations: this.state.authorizations,
        createdByGuid: this.state.createdByGuid,
      };
      var URLParam = "/offers/add";
      if (this.state.guid && this.state.urlSplit.length !== 2) {
        URLParam = "/offers/update";
        myObj = {
          guid: this.state.guid,
          customerGuid: this.state.customerGuid,
          offerDate:
            this.state.offerDate &&
            this.state.offerDate.toString().indexOf("/") > 0
              ? new Date(
                  this.state.offerDate.split("/")[2] +
                    "-" +
                    this.state.offerDate.split("/")[1] +
                    "-" +
                    this.state.offerDate.split("/")[0]
                )
              : moment(this.state.offerDate).format("DD/MM/YYYY"),
          optionDate:
            this.state.optionDate &&
            this.state.optionDate.toString().indexOf("/") > 0
              ? new Date(
                  this.state.optionDate.split("/")[2] +
                    "-" +
                    this.state.optionDate.split("/")[1] +
                    "-" +
                    this.state.optionDate.split("/")[0]
                )
              : moment(this.state.optionDate).format("DD/MM/YYYY"),
          reminderDate:
            this.state.reminderDate &&
            this.state.reminderDate.toString().indexOf("/") > 0
              ? new Date(
                  this.state.reminderDate.split("/")[2] +
                    "-" +
                    this.state.reminderDate.split("/")[1] +
                    "-" +
                    this.state.reminderDate.split("/")[0]
                )
              : moment(this.state.reminderDate).format("DD/MM/YYYY"),
          taxType: this.state.taxTypeValue,
          taxRate: parseInt(this.state.taxRateValue),
          total: parseFloat(this.state.total),
          costTotal: parseFloat(this.state.costTotal),
          generalCostTotal: parseFloat(this.state.generalCostTotal),
          generalTotal: parseFloat(this.state.generalTotal),
          guarantyGuid: this.state.guarantyGuid,
          paymentMethodTypeGuid: this.state.paymentMethodTypeGuid,
          deliveryMethodTypeGuid: this.state.deliveryMethodTypeGuid,
          offerTypeGuid: this.state.offerTypeGuid,
          deliveryTimeGuid: this.state.deliveryTimeGuid,
          description: this.state.descriptionHtml,
          oldOfferDocumentDto: this.state.oldOfferDocumentDto,
          oldOfferImageDto: this.state.oldOfferImageDto,
          coverGuid: this.state.coverGuid,
          currencyType: this.state.currencyType,
          discountPercent:
            this.state.discountPercent !== ""
              ? parseInt(this.state.discountPercent)
              : 0,
          discountValue:
            this.state.discountValue !== ""
              ? parseFloat(this.state.discountValue)
              : 0,
          discountTotal: parseFloat(this.state.discountTotal),
          discountCostTotal: parseFloat(this.state.discountCostTotal),
          status: this.state.status,
          offerProductDto: productData,
          notDescription: this.state.notDescription,
          isExchangeRate: this.state.isExchangeRate,
          dolarValue: this.state.dolarValue,
          euroValue: this.state.euroValue,
          teklifIptalSebebi: this.state.teklifIptalSebebi,
          authorizations: this.state.authorizations,
          createdByGuid: this.state.createdByGuid,
        };
      }
      axios
        .post(URL + URLParam, myObj, config)
        .then(() => {
          setTimeout(() => {
            if (this.state.guid) {
              window.location.href = "/teklif-listele";
            } else {
              window.location.reload();
            }
          }, 1500);
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    } else {
      this.setState({
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  };

  PriceCalculate = async (event) => {
    if (event) {
      const { name, value } = event.target;
      await this.setState({
        [name]: value,
      });
      if (name === "total" && value === "") {
        this.setState({
          totalError: CgnMessage.textErrorMessage,
          alertErrorMessage: CgnMessage.alertErrorMessage,
        });
      }
      if (name === "generalTotal" && value === "") {
        this.setState({
          generalTotalError: CgnMessage.textErrorMessage,
          alertErrorMessage: CgnMessage.alertErrorMessage,
        });
      }
      if (name === "discountTotal" && value === "") {
        this.setState({
          discountTotalError: CgnMessage.textErrorMessage,
          alertErrorMessage: CgnMessage.alertErrorMessage,
        });
      }
      if (name === "discountPercent") {
        await this.setState({
          discountValue: "",
        });
      }
      if (name === "discountValue") {
        await this.setState({
          discountPercent: "",
        });
      }
    }
    var total = parseFloat(this.state.total);
    var costTotal = parseFloat(this.state.costTotal);
    var discountPercent = parseFloat(this.state.discountPercent);
    var discountValue = parseFloat(this.state.discountValue);
    var generalTotal = 0;
    var generalCostTotal = 0;
    var discountTotal = 0;
    var discountCostTotal = 0;
    generalCostTotal = costTotal;
    if (discountPercent > 0) {
      generalTotal = total - total * (discountPercent / 100);
    } else if (discountValue > 0) {
      generalTotal = total - discountValue;
    } else {
      generalTotal = total;
    }
    if (this.state.taxTypeValue && this.state.taxRateValue) {
      if (this.state.taxTypeValue === 1) {
        discountCostTotal =
          generalCostTotal * (this.state.taxRateValue / 100 + 1);
        discountTotal = generalTotal * (this.state.taxRateValue / 100 + 1);
      } else if (this.state.taxTypeValue === 2) {
        discountCostTotal = generalCostTotal;
        discountTotal = generalTotal;
      } else if (this.state.taxTypeValue === 3) {
        discountCostTotal = generalCostTotal;
        discountTotal = generalTotal;
      }
    }
    this.state.costTotal = parseFloat(costTotal).toFixed(2);
    this.state.generalCostTotal = parseFloat(generalCostTotal).toFixed(2);
    this.state.total = parseFloat(total).toFixed(2);
    this.state.generalTotal = parseFloat(generalTotal).toFixed(2);
    this.state.discountCostTotal = parseFloat(discountCostTotal).toFixed(2);
    this.state.discountTotal = parseFloat(discountTotal).toFixed(2);
  };

  render() {
    //const ProductPriceCalculate = this.ProductPriceCalculate();
    const textAreaStyle = {
      padding: "5px 10px",
      height: "100px",
    };

    const mainRow = {
      backgroundColor: "#1d4b8c",
      color: "#fff",
    };
    const subRow = {
      backgroundColor: "#f2f2f2",
    };

    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          addLink={"/" + this.state.pageAddLink}
          listLink={"/" + this.state.pageListLink}
        />
        <Row>
          <Col>
            <Form onSubmit={this.handleSave}>
              <Card body>
                <CgnLoader visibled={this.state.isLoading} />
                {this.state.offerNumber !== 0 && (
                  <Row>
                    <Col lg="2">
                      <CgnTextbox
                        type="number"
                        name="offerNumber"
                        label="Teklif No"
                        value={this.state.offerNumber}
                        readOnly={true}
                      />
                    </Col>
                    <Col lg="10"></Col>
                  </Row>
                )}
                <Row>
                  <Col lg="4">
                    <CgnReactSelect
                      name="offerTypeGuid"
                      label="Teklif Türü"
                      placeholder="Teklif Türü seçiniz..."
                      selectValue={this.state.offerTypeGuid}
                      isMulti={false}
                      isClearable={true}
                      onChange={(option) =>
                        this.handleOfferTypeSelectChange(option)
                      }
                      options={this.state.offerTypeArr}
                    />
                  </Col>
                  <Col lg="8" className="modalSelectCol">
                    <div className="flex-container">
                      <div className="p-0 flexMaxInput">
                        <CgnReactSelect
                          name="customerGuid"
                          label="Müşteri [*]"
                          placeholder="Müşteri seçiniz..."
                          selectValue={this.state.customerGuid}
                          isMulti={false}
                          isClearable={true}
                          onChange={(option) =>
                            this.handleCustomerSelectChange(option)
                          }
                          options={this.state.customerArr}
                          error={this.state.customerError}
                        />
                      </div>
                      {this.state.customerModalPlus && (
                        <div className="p-0 flexAddMinButton">
                          <CgnButton
                            type="button"
                            color="secondary"
                            className="modalSelectAddButton"
                            onClick={() => this.addModalCustomer()}
                            text={"+"}
                          />
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col lg="4">
                    <CgnDatePicker
                      name="offerDate"
                      label="Teklif Tarihi [*]"
                      selected={
                        this.state.offerDate &&
                        this.state.offerDate.toString().indexOf("/") > 0
                          ? new Date(
                              this.state.offerDate.split("/")[2] +
                                "-" +
                                this.state.offerDate.split("/")[1] +
                                "-" +
                                this.state.offerDate.split("/")[0]
                            )
                          : this.state.offerDate
                      }
                      onChange={(offerDate) =>
                        this.handleOfferDateChange(offerDate)
                      }
                      error={this.state.offerDateError}
                      maxDate={new Date(2100, 1, 1)}
                      minDate={new Date(1900, 1, 1)}
                      placeholder="GG/AA/YYYY"
                      autoComplete="off"
                    />
                  </Col>
                  <Col lg="4">
                    <CgnDatePicker
                      name="optionDate"
                      label="Opsiyon Tarihi [*]"
                      selected={
                        this.state.optionDate &&
                        this.state.optionDate.toString().indexOf("/") > 0
                          ? new Date(
                              this.state.optionDate.split("/")[2] +
                                "-" +
                                this.state.optionDate.split("/")[1] +
                                "-" +
                                this.state.optionDate.split("/")[0]
                            )
                          : this.state.optionDate
                      }
                      onChange={(optionDate) =>
                        this.handleOptionDateChange(optionDate)
                      }
                      error={this.state.optionDateError}
                      maxDate={new Date(2100, 1, 1)}
                      minDate={new Date(1900, 1, 1)}
                      placeholder="GG/AA/YYYY"
                      autoComplete="off"
                    />
                  </Col>
                  <Col lg="4">
                    <CgnDatePicker
                      name="reminderDate"
                      label="Hatırlatma Tarihi [*]"
                      selected={
                        this.state.reminderDate &&
                        this.state.reminderDate.toString().indexOf("/") > 0
                          ? new Date(
                              this.state.reminderDate.split("/")[2] +
                                "-" +
                                this.state.reminderDate.split("/")[1] +
                                "-" +
                                this.state.reminderDate.split("/")[0]
                            )
                          : this.state.reminderDate
                      }
                      onChange={(reminderDate) =>
                        this.handleReminderDateChange(reminderDate)
                      }
                      error={this.state.reminderDateError}
                      maxDate={new Date(2100, 1, 1)}
                      minDate={new Date(1900, 1, 1)}
                      placeholder="GG/AA/YYYY"
                      autoComplete="off"
                    />
                  </Col>
                </Row>

                {this.state.productData.map((productData, idx) => (
                  <Row className="mobileBorder">
                    <Col lg="2" className="modalSelectCol">
                      <div className="flex-container">
                        <div className="p-0 flexInput">
                          <CgnReactSelect
                            name="locationGuid"
                            label="Depo [*]"
                            placeholder="Lütfen depo seçiniz..."
                            selectValue={productData.locationGuid}
                            isMulti={false}
                            isClearable={true}
                            onChange={(option) => {
                              this.handleLocationInputValueChange(option, idx);
                            }}
                            options={this.state.locationArr}
                            error={productData.locationError}
                          />
                        </div>
                        {this.state.locationModalPlus && (
                          <div className="p-0 flexAddButton">
                            <CgnButton
                              type="button"
                              color="secondary"
                              className="modalSelectAddButton"
                              onClick={() => this.addModalLocation(idx)}
                              text={"+"}
                            />
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col lg="4" className="modalSelectCol">
                      <div className="flex-container">
                        <div className="p-0 flexInput">
                          <CgnReactSelect
                            name="productGuid"
                            label="Ürün [*]"
                            placeholder="Lütfen ürün seçiniz..."
                            selectValue={productData.productGuid}
                            isMulti={false}
                            isClearable={true}
                            onChange={(option) => {
                              this.handleProductInputValueChange(option, idx);
                            }}
                            options={this.state.productArr}
                            error={productData.productError}
                          />
                        </div>
                        {this.state.productModalPlus && (
                          <div className="p-0 flexAddButton">
                            <CgnButton
                              type="button"
                              color="secondary"
                              className="modalSelectAddButton"
                              onClick={() => this.addModalProduct(idx)}
                              text={"+"}
                            />
                          </div>
                        )}
                      </div>
                    </Col>

                    <Col lg="1">
                      <CgnTextbox
                        type="number"
                        name="piece"
                        label="Adet [*]"
                        value={productData.piece}
                        onChange={(e) =>
                          this.handleProductPieceTextBoxChange(e, idx)
                        }
                        placeHolder="Lütfen adet girin..."
                        maxLength="50"
                        autoComplete="off"
                        error={productData.productPieceError}
                      />
                    </Col>

                    <Col lg="1">
                      <CgnTextbox
                        type="number"
                        name="costPrice"
                        label="M. Birim Fiyat"
                        value={productData.costPrice}
                        onChange={(e) =>
                          this.handleProductCostPriceTextBoxChange(e, idx)
                        }
                        placeHolder="Lütfen birim fiyat girin..."
                        maxLength="50"
                        autoComplete="off"
                      />
                    </Col>

                    <Col lg="1">
                      <CgnTextbox
                        type="number"
                        name="unitPrice"
                        label="Birim Fiyat [*]"
                        value={productData.unitPrice}
                        onChange={(e) =>
                          this.handleProductUnitPriceTextBoxChange(e, idx)
                        }
                        placeHolder="Lütfen birim fiyat girin..."
                        maxLength="50"
                        autoComplete="off"
                        error={productData.productUnitPriceError}
                      />
                    </Col>

                    <Col lg="1">
                      <CgnTextbox
                        type="number"
                        name="costTotal"
                        label="Maliyet Fiyat"
                        value={productData.costTotal}
                        readOnly={true}
                        onChange={this.ProductPriceCalculate()}
                        maxLength="50"
                        autoComplete="off"
                      />
                    </Col>

                    <Col lg="1">
                      <CgnTextbox
                        type="number"
                        name="total"
                        label="Fiyat"
                        value={productData.total}
                        readOnly={true}
                        onChange={this.ProductPriceCalculate()}
                        maxLength="50"
                        autoComplete="off"
                      />
                    </Col>

                    <Col lg="1" sm="3">
                      <CgnButton
                        className="dynamicRowDeleteButton"
                        type="button"
                        color="danger"
                        onClick={() => this.handleProductRemove(idx)}
                        text={"Sil"}
                      />
                    </Col>
                  </Row>
                ))}

                <Row>
                  <Col lg="2">
                    <CgnButton
                      type="button"
                      color="primary"
                      className="dynamicRowAddButton"
                      onClick={this.handleProductAdd}
                      text={"Ürün Ekle"}
                    />
                    <CgnButton
                      type="button"
                      color="primary"
                      className="ml-2 dynamicRowAddButton"
                      onClick={this.toggle}
                      text={"Çoklu Ürün Ekle"}
                    />
                  </Col>
                  {this.state.productDataError && (
                    <div className="invalid-feedback d-block">
                      {this.state.productDataError}
                    </div>
                  )}
                </Row>

                <Row className="mt-3">
                  <Col lg="2">
                    <CgnTextbox
                      type="number"
                      name="costTotal"
                      label="Maliyet Tutar"
                      value={this.state.costTotal}
                      maxLength="50"
                      autoComplete="off"
                      readOnly={true}
                      onChange={this.PriceCalculate}
                    />
                  </Col>
                  <Col lg="2">
                    <CgnTextbox
                      type="number"
                      name="total"
                      label="Tutar"
                      value={this.state.total}
                      maxLength="50"
                      autoComplete="off"
                      readOnly={true}
                      onChange={this.PriceCalculate}
                    />
                  </Col>
                  <Col lg="2">
                    <CgnTextbox
                      type="number"
                      name="discountPercent"
                      label="İskonto(Yüzde)"
                      value={this.state.discountPercent}
                      placeHolder="Lütfen iskonto girin..."
                      maxLength="50"
                      autoComplete="off"
                      readOnly={this.state.isDiscountPercent}
                      onChange={this.PriceCalculate}
                      error={this.state.discountPercentError}
                    />
                  </Col>
                  <Col lg="2">
                    <CgnTextbox
                      type="number"
                      name="discountValue"
                      label="İskonto(Net Tutar)"
                      value={this.state.discountValue}
                      placeHolder="Lütfen iskonto net tutar girin..."
                      maxLength="50"
                      autoComplete="off"
                      readOnly={this.state.isDiscountValue}
                      onChange={this.PriceCalculate}
                      error={this.state.discountValueError}
                    />
                  </Col>
                  <Col lg="2">
                    <CgnTextbox
                      type="number"
                      name="generalTotal"
                      label="Maliyet Genel Tutar"
                      value={this.state.generalCostTotal}
                      maxLength="50"
                      autoComplete="off"
                      readOnly={true}
                      onChange={this.PriceCalculate}
                    />
                  </Col>
                  <Col lg="2">
                    <CgnTextbox
                      type="number"
                      name="generalTotal"
                      label="Genel Tutar"
                      value={this.state.generalTotal}
                      maxLength="50"
                      autoComplete="off"
                      readOnly={true}
                      onChange={this.PriceCalculate}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg="4">
                    <CgnReactSelect
                      name="currencyType"
                      label="Para Birimi [*]"
                      placeholder="Lütfen para birimi seçiniz..."
                      selectValue={this.state.currencyType}
                      isMulti={false}
                      isClearable={true}
                      onChange={(option) =>
                        this.handleCurrencyTypeSelectChange(option)
                      }
                      options={CurrencyType}
                      error={this.state.currencyTypeError}
                    />
                  </Col>
                  <Col lg="2">
                    <CgnReactSelect
                      name="isExchangeRate"
                      label="Döviz Kuru"
                      selectValue={this.state.isExchangeRate}
                      isMulti={false}
                      options={viewExchangeRate}
                      onChange={(isExchangeRate) =>
                        this.handleIsExchangeRateSelectChange(isExchangeRate)
                      }
                      placeholder="Lütfen döviz kuru seçiniz..."
                    />
                  </Col>
                  <Col lg="2">
                    <CgnTextbox
                      type="number"
                      name="exchangeRate"
                      label="Teklif Kuru"
                      value={this.state.exchangeRate}
                      placeHolder="Lütfen teklif kuru girin..."
                      maxLength="50"
                      autoComplete="off"
                      readOnly={true}
                      onChange={this.handleChange}
                    />
                  </Col>
                  <Col lg="2">
                    <CgnTextbox
                      type="number"
                      name="dolarValue"
                      label="Dolar Kuru"
                      value={this.state.dolarValue}
                      placeHolder="Lütfen dolar kuru girin..."
                      maxLength="50"
                      autoComplete="off"
                      onChange={this.handleChange}
                    />
                  </Col>
                  <Col lg="2">
                    <CgnTextbox
                      type="number"
                      name="euroValue"
                      label="Euro Kuru"
                      value={this.state.euroValue}
                      placeHolder="Lütfen euro kuru girin..."
                      maxLength="50"
                      autoComplete="off"
                      onChange={this.handleChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg="3">
                    <CgnReactSelect
                      name="taxTypeValue"
                      label="K.D.V Türü [*]"
                      placeholder="Lütfen K.D.V türü seçiniz..."
                      selectValue={this.state.taxTypeValue}
                      isMulti={false}
                      isClearable={true}
                      onChange={(option) =>
                        this.handleTaxTypeSelectChange(option)
                      }
                      options={TaxType}
                      error={this.state.taxTypeError}
                    />
                  </Col>
                  <Col lg="3">
                    <CgnReactSelect
                      name="taxRateValue"
                      label="K.D.V Oranı [*]"
                      placeholder="Lütfen K.D.V oranı seçiniz..."
                      selectValue={this.state.taxRateValue}
                      isMulti={false}
                      isClearable={true}
                      disabled={this.state.isTrue}
                      onChange={(option) =>
                        this.handleTaxRateSelectChange(option)
                      }
                      options={TaxRateChoices}
                      error={this.state.taxRateError}
                    />
                  </Col>
                  <Col lg="3">
                    <CgnTextbox
                      type="number"
                      name="discountCostTotal"
                      label="Toplam Maliyet"
                      value={this.state.discountCostTotal}
                      maxLength="50"
                      autoComplete="off"
                      readOnly={true}
                      onChange={this.PriceCalculate}
                    />
                  </Col>
                  <Col lg="3">
                    <CgnTextbox
                      type="number"
                      name="discountTotal"
                      label="Toplam Tutar"
                      value={this.state.discountTotal}
                      maxLength="50"
                      autoComplete="off"
                      readOnly={true}
                      onChange={this.PriceCalculate}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg="6">
                    {/* <CgnTextbox
                      type="text"
                      name="paymentMethodType"
                      label="Ödeme Yöntemi"
                      placeholder="Lütfen ödeme yöntemi girin..."
                      value={this.state.paymentMethodType}
                      maxLength="255"
                      autoComplete="off"
                      onChange={this.handleChange}
                    /> */}
                    <div className="flex-container">
                      <div className="p-0 flexMaxInput">
                        <CgnReactSelect
                          name="customerGuid"
                          label="Ödeme Yöntemi"
                          placeholder="Ödeme yöntemi seçiniz..."
                          selectValue={this.state.paymentMethodTypeGuid}
                          isMulti={false}
                          isClearable={true}
                          onChange={(option) =>
                            this.handlePaymentMethodTypeSelectChange(option)
                          }
                          options={this.state.definitionData}
                          error={this.state.paymentMethodTypeError}
                        />
                      </div>
                      {this.state.definitionModalPlus && (
                        <div className="p-0 flexAddMinButton">
                          <CgnButton
                            type="button"
                            color="secondary"
                            className="modalSelectAddButton"
                            onClick={() =>
                              this.addModalDefinitionPaymentMethodType()
                            }
                            text={"+"}
                          />
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col lg="6">
                    {/* <CgnTextbox
                      type="text"
                      name="deliveryMethodType"
                      label="Teslimat Yöntemi"
                      placeholder="Lütfen teslimat yöntemi girin..."
                      value={this.state.deliveryMethodType}
                      maxLength="255"
                      autoComplete="off"
                      onChange={this.handleChange}
                    /> */}
                    <div className="flex-container">
                      <div className="p-0 flexMaxInput">
                        <CgnReactSelect
                          name="customerGuid"
                          label="Teslimat Yöntemi"
                          placeholder="Teslimat yöntemi seçiniz..."
                          selectValue={this.state.deliveryMethodTypeGuid}
                          isMulti={false}
                          isClearable={true}
                          onChange={(option) =>
                            this.handleDeliveryMethodTypeSelectChange(option)
                          }
                          options={this.state.definitionData}
                          error={this.state.deliveryMethodTypeError}
                        />
                      </div>
                      {this.state.definitionModalPlus && (
                        <div className="p-0 flexAddMinButton">
                          <CgnButton
                            type="button"
                            color="secondary"
                            className="modalSelectAddButton"
                            onClick={() =>
                              this.addModalDefinitionDeliveryMethodType()
                            }
                            text={"+"}
                          />
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col lg="6">
                    {/* <CgnTextbox
                      type="text"
                      name="deliveryTime"
                      label="Teslimat Süresi"
                      placeholder="Lütfen teslimat süresi girin..."
                      value={this.state.deliveryTime}
                      maxLength="255"
                      autoComplete="off"
                      onChange={this.handleChange}
                    /> */}
                    <div className="flex-container">
                      <div className="p-0 flexMaxInput">
                        <CgnReactSelect
                          name="customerGuid"
                          label="Teslimat Süresi"
                          placeholder="Teslimat süresi seçiniz..."
                          selectValue={this.state.deliveryTimeGuid}
                          isMulti={false}
                          isClearable={true}
                          onChange={(option) =>
                            this.handleDeliveryTimeSelectChange(option)
                          }
                          options={this.state.definitionData}
                          error={this.state.deliveryTimeError}
                        />
                      </div>
                      {this.state.definitionModalPlus && (
                        <div className="p-0 flexAddMinButton">
                          <CgnButton
                            type="button"
                            color="secondary"
                            className="modalSelectAddButton"
                            onClick={() =>
                              this.addModalDefinitionDeliveryTime()
                            }
                            text={"+"}
                          />
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col lg="6">
                    {/* <CgnTextbox
                      type="text"
                      name="guaranty"
                      label="Garanti Süresi"
                      placeholder="Lütfen garanti süresi girin..."
                      value={this.state.guaranty}
                      maxLength="255"
                      autoComplete="off"
                      onChange={this.handleChange}
                    /> */}
                    <div className="flex-container">
                      <div className="p-0 flexMaxInput">
                        <CgnReactSelect
                          name="customerGuid"
                          label="Garanti Süresi"
                          placeholder="Garanti süresi seçiniz..."
                          selectValue={this.state.guarantyGuid}
                          isMulti={false}
                          isClearable={true}
                          onChange={(option) =>
                            this.handleGuarantySelectChange(option)
                          }
                          options={this.state.definitionData}
                          error={this.state.guarantyError}
                        />
                      </div>
                      {this.state.definitionModalPlus && (
                        <div className="p-0 flexAddMinButton">
                          <CgnButton
                            type="button"
                            color="secondary"
                            className="modalSelectAddButton"
                            onClick={() => this.addModalDefinitionGuaranty()}
                            text={"+"}
                          />
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg="12">
                    <CgnTextEditor
                      name="description"
                      label="Teklif Notu"
                      editorState={this.state.description}
                      placeHolder="Lütfen teklif notu girin..."
                      onChange={(editorState) =>
                        this.handleEditorChange(
                          editorState,
                          draftToHtml(
                            convertToRaw(editorState.getCurrentContent())
                          )
                        )
                      }
                      error={this.state.descriptionError}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg="12">
                    <CgnTextbox
                      inlineStyle={textAreaStyle}
                      type="textarea"
                      name="notDescription"
                      label="Firma Açıklama"
                      value={this.state.notDescription}
                      placeHolder="Lütfen açıklama girin..."
                      //maxLength="255"
                      autoComplete="off"
                      onChange={this.handleChange}
                      //error={this.state.descriptionError}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg={12}>
                    <Label className="font-weight-bolder">Teklif Kapağı</Label>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col lg={12}>
                    {this.state.offerCoverData.map((item) => (
                      <Button
                        type="button"
                        className="offerCoverButton"
                        onClick={() =>
                          this.handleOfferCoverSelectChange(item.value)
                        }
                      >
                        {this.state.coverGuid === item.value ? (
                          <img
                            src={item.src}
                            alt={item.label}
                            className="offerCoverImage offerCoverImageSelected"
                          />
                        ) : (
                          <img
                            src={item.src}
                            alt={item.label}
                            className="offerCoverImage"
                          />
                        )}
                      </Button>
                    ))}
                  </Col>
                  {this.state.offerCoverError && (
                    <div className="invalid-feedback d-block">
                      {this.state.offerCoverError}
                    </div>
                  )}
                </Row>

                <Row>
                  <Col lg="2" className="mb-2">
                    <CgnButton
                      type="button"
                      color="primary"
                      className="dynamicRowAddButton"
                      onClick={this.addModalOfferCover}
                      text={"Teklif Kapağı Ekle"}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg="12">
                    <ImageUploadMulti
                      images={this.state.oldOfferDocumentDto}
                      noFoto={noImg}
                      style={fotoStyle}
                      pdfIcon={pdfIcon}
                      accept="application/pdf"
                      className="text-center text-danger"
                      label={"Teklif Dosyaları"}
                      onChange={this.uploadedImage3}
                      onDelete={this.deleteImage3}
                      //error={this.state.imageError2}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg="12">
                    <PictureUploadMulti
                      image={this.state.oldOfferImageDto}
                      noFoto={noImg}
                      style={fotoStyle}
                      accept="image/png, image/jpeg"
                      className="text-center text-danger"
                      label={"Teklif Fotoğrafları"}
                      onChange={this.uploadedImage}
                      onDelete={this.deleteImage}
                      alt={this.state.name}
                      //error={this.state.imageError2}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg="12">
                    <h2 className="mt-2 mb-2">Yetkilendirme</h2>
                  </Col>
                </Row>

                <Row>
                  <Col lg="5" className="px-0">
                    <CgnReactSelect
                      name="userGuid"
                      label="Kullanıcı"
                      placeholder="Kullanıcı seçiniz..."
                      selectValue={this.state.userGuid}
                      isMulti={false}
                      onChange={(option) => this.handleUserSelectChange(option)}
                      options={this.state.userArr}
                    />
                  </Col>
                  <Col lg="2" className="pr-0">
                    <CgnReactSelect
                      name="isRead"
                      label="Okuma Yetkisi"
                      placeholder="Okuma yetkisi seçiniz..."
                      selectValue={this.state.isRead}
                      isMulti={false}
                      onChange={(option) => this.handleReadSelectChange(option)}
                      options={yesNoStatus}
                    />
                  </Col>
                  <Col lg="2" className="pr-0">
                    <CgnReactSelect
                      name="isWrite"
                      label="Yazma Yetkisi"
                      placeholder="Yazma yetkisi seçiniz..."
                      selectValue={this.state.isWrite}
                      isMulti={false}
                      onChange={(option) =>
                        this.handleWriteSelectChange(option)
                      }
                      options={yesNoStatus}
                    />
                  </Col>
                  <Col lg="2" className="pr-0">
                    <CgnReactSelect
                      name="isDelete"
                      label="Silme Yetkisi"
                      placeholder="Silme yetkisi seçiniz..."
                      selectValue={this.state.isDelete}
                      isMulti={false}
                      onChange={(option) =>
                        this.handleDeleteSelectChange(option)
                      }
                      options={yesNoStatus}
                    />
                  </Col>
                  <Col lg="1">
                    <CgnButton
                      type="button"
                      color="primary"
                      className="dynamicRowDeleteButton"
                      onClick={this.handleAuthorizationAdd}
                      text="Ekle"
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg="12">
                    <Table className="table table-responsive table-hover table-product mt-0 mb-4">
                      <tbody>
                        <tr style={mainRow}>
                          <th className="w-auto">Kullanıcı Ad Soyad</th>
                          <th className="w-300 text-center">Okuma Yetkisi</th>
                          <th className="w-300 text-center">Yazma Yetkisi</th>
                          <th className="w-300 text-center">Silme Yetkisi</th>
                          <th className="w-100 text-center">İşlem</th>
                        </tr>
                        {this.state.authorizations?.map((item) => (
                          <tr style={subRow} key={item.memberGuid}>
                            <td className="pl-2 align-middle">
                              {item.memberNameSurname}
                            </td>
                            <td className="text-center align-middle">
                              {item.isRead ? "Evet" : "Hayır"}
                            </td>
                            <td className="text-center align-middle">
                              {item.isWrite ? "Evet" : "Hayır"}
                            </td>
                            <td className="text-center align-middle">
                              {item.isDelete ? "Evet" : "Hayır"}
                            </td>
                            <td className="text-center align-middle">
                              <CgnButton
                                type="button"
                                color="danger"
                                onClick={() =>
                                  this.handleAuthorizationRemove(item.guid)
                                }
                                text={"Sil"}
                                disabled={!item.isChanged}
                                className="dynamicRowDeleteButton mt-0"
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Col>
                </Row>

                <Row>
                  <Col lg="6">
                    <CgnReactSelect
                      name="status"
                      label="Durumu"
                      selectValue={this.state.status}
                      isMulti={false}
                      options={optionOfferStatuses}
                      onChange={(status) =>
                        this.handleStatusSelectChange(status)
                      }
                    />
                  </Col>
                  <Col lg="6">
                    <CgnReactSelect
                      name="createdByGuid"
                      label="Ekleyen Kullanıcı"
                      placeholder="Kullanıcı seçiniz..."
                      selectValue={this.state.createdByGuid}
                      isMulti={false}
                      onChange={(option) =>
                        this.handleUser2SelectChange(option)
                      }
                      options={this.state.userArr2}
                    />
                  </Col>
                </Row>

                {this.state.status === 3 && (
                  <Row>
                    <Col lg="12">
                      <CgnTextbox
                        inlineStyle={textAreaStyle}
                        type="textarea"
                        name="teklifIptalSebebi"
                        label="Teklif İptal Sebebi"
                        value={this.state.teklifIptalSebebi}
                        placeHolder="Lütfen teklif iptal sebebi girin..."
                        autoComplete="off"
                        onChange={this.handleChange}
                        error={this.state.teklifIptalSebebiError}
                      />
                    </Col>
                  </Row>
                )}

                {this.state.alertErrorMessage && (
                  <CgnAlert
                    color="danger"
                    title={CgnMessage.alertErrorTitle}
                    text={this.state.alertErrorMessage}
                  />
                )}
                <CgnButtonGroup items={this.state.buttons} />

                <Row>
                  <Modal
                    isOpen={this.state.offerMultipleModal}
                    toggle={this.toggle}
                  >
                    <ModalHeader
                      toggle={this.toggle}
                      className="font-weight-bold"
                    >
                      Çoklu Ürün Ekle
                    </ModalHeader>
                    <ModalBody className="modalBody">
                      <Input
                        type="textarea"
                        className="modalTextArea"
                        onChange={(e) => this.handleChangeMultipleProduct(e)}
                      />
                    </ModalBody>
                    <ModalFooter>
                      <CgnButton
                        type="button"
                        color="primary"
                        onClick={() => this.handleClickMultipleProduct()}
                        text={CgnMessage.addButton}
                        className="modalButton"
                      />
                      <CgnButton
                        type="button"
                        color="secondary"
                        onClick={this.toggle}
                        text="Kapat"
                        className="modalButton"
                      />
                    </ModalFooter>
                  </Modal>
                </Row>
              </Card>
            </Form>
            <CgnButtonLink
              color="secondary"
              to={"/" + this.state.pageListLink}
              text={CgnMessage.backButton}
              className="btn-back"
            />
          </Col>
        </Row>
        <Modal
          isOpen={this.state.isOpenModalCustomer}
          toggle={this.addModalCustomer}
          className="modal-xl content"
        >
          <ModalHeader className="font-weight-bold">Müşteri Ekle</ModalHeader>
          <ModalBody className="modalBody">
            <CustomerAddUpdate />
          </ModalBody>
          <ModalFooter>
            <CgnButton
              type="button"
              color="secondary"
              onClick={this.addModalCustomer}
              text="Kapat"
              className="modalButton"
            />
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={this.state.isOpenModalProduct}
          toggle={this.addModalProduct}
          className="modal-xl content"
        >
          <ModalHeader className="font-weight-bold">Ürün Ekle</ModalHeader>
          <ModalBody className="modalBody">
            <ProductAddUpdate />
          </ModalBody>
          <ModalFooter>
            <CgnButton
              type="button"
              color="secondary"
              onClick={this.addModalProduct}
              text="Kapat"
              className="modalButton"
            />
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={this.state.isOpenModalOfferCover}
          toggle={this.addModalOfferCover}
          className="modal-xl content"
        >
          <ModalHeader className="font-weight-bold">
            Teklif Kapağı Ekle
          </ModalHeader>
          <ModalBody className="modalBody">
            <OfferCoverAddUpdate />
          </ModalBody>
          <ModalFooter>
            <CgnButton
              type="button"
              color="secondary"
              onClick={this.addModalOfferCover}
              text="Kapat"
              className="modalButton"
            />
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={this.state.isOpenModalDefinition}
          toggle={this.addModalDefinition}
          className="modal-xl content"
        >
          <ModalHeader className="font-weight-bold">Tanımlama Ekle</ModalHeader>
          <ModalBody className="modalBody">
            <OfferDefinitionAddUpdate />
          </ModalBody>
          <ModalFooter>
            <CgnButton
              type="button"
              color="secondary"
              onClick={this.addModalDefinition}
              text="Kapat"
              className="modalButton"
            />
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={this.state.isOpenModalLocation}
          toggle={this.addModalLocation}
          className="modal-xl content"
        >
          <ModalHeader className="font-weight-bold">Depo Ekle</ModalHeader>
          <ModalBody className="modalBody">
            <LocationAddUpdate />
          </ModalBody>
          <ModalFooter>
            <CgnButton
              type="button"
              color="secondary"
              onClick={this.addModalLocation}
              text="Kapat"
              className="modalButton"
            />
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

export default OfferAddUpdate;
